import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import React, { FC } from "react";
import { COLOR_PRIMARY_MAIN } from "shared/theme/colors";
import { AddCircleIcon } from "shared/theme/icons/AddCircleIcon";
import { StyledNoOptionContainer } from "./styled";

type Props = {
  inputValue?: string;
  onClick: () => void;
};

const EmptyOptions: FC<Props> = (props) => {
  return (
    <StyledNoOptionContainer onClick={props.onClick}>
      <Typography
        fontWeight="600"
        variant="bodyMMedium"
        color={COLOR_PRIMARY_MAIN}
        data-testid={`new-type-${props.inputValue}`}
      >
        {props.inputValue}
      </Typography>

      <Box display="flex" alignItems="center" data-testid="add-new-tag-type">
        <AddCircleIcon />
        <Typography
          color={COLOR_PRIMARY_MAIN}
          variant="bodyMMedium"
          ml="10px"
          fontWeight="600"
        >
          Add New Tag
        </Typography>
      </Box>
    </StyledNoOptionContainer>
  );
};

export default EmptyOptions;
